// Applies the `data-theme` attribute on <html>. The inline script in
// index.html runs this once before React mounts so the user never sees a
// flash of the wrong palette. The ThemeToggle component calls setTheme()
// to switch + persist.

const KEY = 'aqs.theme';
const VALID = new Set(['light', 'dark']);

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(KEY);
    return VALID.has(v) ? v : null;
  } catch {
    return null;
  }
}

export function getSystemTheme() {
  try {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(mode) {
  if (!VALID.has(mode)) mode = 'dark';
  document.documentElement.setAttribute('data-theme', mode);
}

export function setTheme(mode) {
  try {
    localStorage.setItem(KEY, mode);
  } catch {}
  applyTheme(mode);
}

// Initial resolution: stored wins, else brand-default dark. We
// intentionally don't follow `prefers-color-scheme` for first-time
// visitors — the rest of the site (/, /demo, /admin, /changelog) is
// dark-only, and landing on a different palette in /app feels like
// a different product.
export function initTheme() {
  const stored = getStoredTheme();
  applyTheme(stored || 'dark');
}
